import { Body, Box, Icon, Loader, VStack, motion } from '@hover/blueprint';
import { iconAlert } from '@hover/icons';
import React from 'react';

import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

const MotionBox = motion(Box);

type LoadingOverlayProps = {
  hasError: boolean;
};

export const BuildingLoadingOverlay = React.forwardRef<
  HTMLDivElement,
  LoadingOverlayProps
>(({ hasError }, ref) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return (
    <MotionBox
      alignItems="center"
      animate={{ opacity: 1 }}
      backgroundColor="neutral.100"
      bottom={0}
      exit={{
        opacity: 0,
        transition: { delay: 0.2, duration: 0.35 },
      }}
      initial={{ opacity: 0 }}
      justifyContent="center"
      left={0}
      position="absolute"
      ref={ref}
      right={0}
      top={0}
    >
      {hasError ? (
        <VStack alignItems="center" justifyContent="center" padding="500">
          <Icon color="neutral.600" icon={iconAlert} />
          <Body color="neutral.600">
            {t('projects.scan.modelLoadingError')}
          </Body>
        </VStack>
      ) : (
        <Loader color="neutral.600" size="large" />
      )}
    </MotionBox>
  );
});
